import PropTypes from "prop-types";
import CustomModal from "../CustomModal";

const StaffStatusModal = ({
  isOpen,
  onRequestClose,
  type = "success",
  title,
  description,
  primaryButtonText = "Close",
  secondaryButtonText = null,
  onPrimaryClick = null,
  onSecondaryClick = null,
  showCredentials = false,
  loginId = "",
  password = "",
  className = "edit-success-modal",
  reload = false,
}) => {
  const getImagePath = () => {
    switch (type) {
      case "success":
        return "/images/thumbs-up.png";
      case "warning":
        return "/images/delete-danger.png";
      case "enable":
        return "/images/enable-modal-img.png";
      case "disable":
        return "/images/disable-modal-img.png";
      default:
        return "/images/thumbs-up.png";
    }
  };

  const handlePrimaryClick = () => {
    if (onPrimaryClick) {
      onPrimaryClick();
    } else {
      onRequestClose();
      if (reload) window.location.reload();
    }
  };

  const handleSecondaryClick = () => {
    if (onSecondaryClick) {
      onSecondaryClick();
    } else {
      onRequestClose();
    }
  };

  const getButtonStyle = () => {
    switch (type) {
      case "warning":
        return { backgroundColor: "#dc3545", color: "#fff" };
      case "enable":
        return { backgroundColor: "#0473DB", color: "#fff" };
      case "disable":
        return { backgroundColor: "#DD9828", color: "#FAFAFA" };
      default:
        return {};
    }
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={className}
      contentLabel={`${title} Modal`}
    >
      <img
        src={`${process.env.PUBLIC_URL}${getImagePath()}`}
        alt={
          type === "success"
            ? "Success thumbs up icon"
            : type === "warning"
            ? "Warning icon"
            : type === "enable"
            ? "Enable user icon"
            : type === "disable"
            ? "Disable user icon"
            : "Status icon"
        }
      />
      <h2>{title}</h2>
      {description && <p>{description}</p>}

      {showCredentials && (
        <div className="details-container container" style={{ width: "100%" }}>
          <div className="detail">
            <p>Login ID</p>
            <b>
              <p className="D">{loginId}</p>
            </b>
          </div>
          <div className="detail">
            <p>Password</p>
            <b>
              <p className="D">{password}</p>
            </b>
          </div>
        </div>
      )}

      <div className={secondaryButtonText ? "delete-modal-button" : ""}>
        {secondaryButtonText && (
          <button
            className="delete-btn1"
            style={getButtonStyle()}
            onClick={handlePrimaryClick}
          >
            {primaryButtonText}
          </button>
        )}
        <button
          className={secondaryButtonText ? "delete-btn2" : ""}
          type="button"
          onClick={
            secondaryButtonText ? handleSecondaryClick : handlePrimaryClick
          }
        >
          {secondaryButtonText || primaryButtonText}
        </button>
      </div>
    </CustomModal>
  );
};

StaffStatusModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["success", "warning", "enable", "disable"]),
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  primaryButtonText: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  onPrimaryClick: PropTypes.func,
  onSecondaryClick: PropTypes.func,
  showCredentials: PropTypes.bool,
  loginId: PropTypes.string,
  password: PropTypes.string,
  className: PropTypes.string,
  reload: PropTypes.bool,
};

export default StaffStatusModal;
